import React from "react";
import { useNavigate } from "react-router-dom";

// Icons & Images
import Morale from "assets/icons/improve_morale.svg";
import ArrowChart from "assets/icons/arr-chart.svg";
import Diamond from "assets/icons/diamond.svg";
import Ammuni from "assets/icons/ammuni.svg";
import Military from "assets/icons/military.svg";
import AB from "assets/icons/ab.svg";
import CV from "assets/icons/cv.svg";
import SV from "assets/icons/sv.svg";
// import ChangeArrowRed from "assets/icons/change-arrowdown-red.svg";
// import MeasureUp from "assets/icons/measure-up.svg";
// import MeasureDown from "assets/icons/measure-down.svg";
// import MeasureStraight from "assets/icons/measure-straight.svg";
import ArrowAmber from "assets/icons/arrow-amber.svg";
import ArrowRed from "assets/icons/arrow-red.svg";
import ArrowGreen from "assets/icons/arrow-green.svg";


// Scss
import "./StrategicObjectives.scss";

function StrategicObjectives() {
  let navgiate = useNavigate();
  function redirectPage(to) {
    navgiate(to);
  }
  function convertValues(number) {
    number = number.toString().replace(/,/g, "");
    var formatter = new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
    });

    if (number < 1000000 && number > 1000) {
      // Anything less than a million

      return formatter.format(number) + " K";
    } else if (number < 1000000000 && number > 1000000) {
      // Anything less than a billion

      number = number / 1000000;

      return formatter.format(number) + " M";
    } else if (number > 1000000000) {
      // At least a billion

      number = number / 1000000000;

      return formatter.format(number) + " B";
    } else {
      return formatter.format(number);
    }
  }
  return (
    <>
      {/* Section & Details Start */}
      <section className="objective-tile">
        <div className="left-content">
          <div
            className="improve-morale"
            onClick={() => {
              redirectPage("/impacts-tracking-dashboard?so=1");
            }}
          >
            <div className="green-patch">
              <img src={Morale} alt="icon1" />
            </div>

            <div className="improve-morale-text">
              <div className="green-circle">
                <span>1</span>
              </div>
              <span>
                Improve morale and individual performance of MOD staff
              </span>
            </div>
          </div>
        </div>
        <div className="right-content">
          <div className="impact-status">
            <div className="top-title">
              <div className="lines gap-right">
                <hr />
              </div>
              <div>
                <span>Impact Status</span>
              </div>
              <div className="lines gap-left">
                <hr />
              </div>
            </div>

            <div className="istatus-measures">
              <div className="istatus">
                <div className="impact-title">
                  <span>Employee Retention</span>
                  <div
                    className="impact-progress bar green"
                    onClick={() => {
                      redirectPage("/impacts-tracking?selected=retention");
                    }}
                  ></div>
                </div>
                <div className="impact-title  sec-title">
                  <span>Employee Satisfaction</span>
                  <div
                    className="impact-progress bar amber"
                    onClick={() => {
                      redirectPage("/impacts-tracking?selected=satisfaction");
                    }}
                  ></div>
                </div>
                <div className="impact-title  sec-title">
                  <span>Employee Complaints</span>
                  <div
                    className="impact-progress bar red"
                    onClick={() => {
                      redirectPage("/impacts-tracking?selected=compliants");
                    }}
                  ></div>
                </div>
              </div>
              <div className="imeasure">
                <div className="tmeasure">
                  <span>Target Measure</span>
                  <ul>
                    <li className="green-text">75%</li>
                    <li className="amber-text">90%</li>
                    <li className="red-text">10%</li>
                  </ul>
                </div>
                <div className="cmeasure">
                  <span>Current Measure</span>
                  <ul>
                    <li className="green-text">
                      75% <img src={ArrowGreen} alt="#" />
                    </li>
                    <li className="amber-text">
                      80% <img src={ArrowAmber} alt="#" className="rotate-down"/>
                    </li>
                    <li className="red-text">
                      25% <img src={ArrowRed} alt="#" className="rotate-up" />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="objective-more-details">
        <div className="cont">
          <div className="linked-projects">
            <div className="top-title">
              <div className="lines gap-right">
                <hr />
              </div>
              <div>
                <span>Linked Initiatives</span>
              </div>
              <div className="lines gap-left">
                <hr />
              </div>
            </div>

            <div className="counter-linked">
              <span>87</span>
            </div>
          </div>
          <div className="initiatives">
            <div className="top-title">
              <div className="lines gap-right">
                <hr />
              </div>
              <div>
                <span>Initiatives</span>
              </div>
              <div className="lines gap-left">
                <hr />
              </div>
            </div>

            <div className="detail-initiate">
              <div className="left-track">
                <div className="on-track-cover">
                  <span className="on-track">On Track</span>
                  <span className="track-count">30</span>
                </div>

                <div className="moderate-cover">
                  <span className="moderate">Moderate Delay</span>
                  <span className="mod-count">30</span>
                </div>
              </div>
              <div className="right-track">
                <div className="sig-cover">
                  <span className="sig-delay">Significant Delay</span>
                  <span className="sig-count">20</span>
                </div>

                <div className="not-cover">
                  <span className="not-started">Not Started</span>
                  <span className="not-count">7</span>
                </div>
              </div>
            </div>
          </div>
          <div className="tile right">
            <div className="icon">
              <img src={AB} alt="#" />
            </div>
            <span>Approved Budget</span>
            <span>{ convertValues('19234545343') }</span>
          </div>
          <div className="tile right">
            <div className="icon">
              <img src={CV} alt="#" />
            </div>
            <span>Contracted Value</span>
            <span>{ convertValues('5623421133') }</span>
          </div>
          <div className="tile right">
            <div className="icon">
              <img src={SV} alt="#" />
            </div>
            <span>Spent Value</span>
            <span>{ convertValues('95673432') }</span>
          </div>
        </div>
      </section>
      {/* Section & Details End */}

      {/* Section & Details Start */}
      <section className="objective-tile">
        <div className="left-content">
          <div
            className="improve-morale"
            onClick={() => {
              redirectPage("/impacts-tracking-dashboard?so=2");
            }}
          >
            <div className="green-patch">
              <img src={ArrowChart} alt="icon1" />
            </div>

            <div className="improve-morale-text">
              <div className="green-circle">
                <span>2</span>
              </div>
              <span>Develop MoD’s organizational performance</span>
            </div>
          </div>
        </div>
        <div className="right-content">
          <div className="impact-status">
            <div className="top-title">
              <div className="lines gap-right">
                <hr />
              </div>
              <div>
                <span>Impact Status</span>
              </div>
              <div className="lines gap-left">
                <hr />
              </div>
            </div>

            <div className="istatus-measures">
              <div className="istatus">
                <div className="impact-title">
                  <span>TOM Process Activation</span>
                  <div
                    className="impact-progress bar red"
                    onClick={() => {
                      redirectPage("/impacts-tracking?selected=retention");
                    }}
                  ></div>
                </div>
                <div className="impact-title  sec-title">
                  <span>Fullfill Forces Requirements</span>
                  <div
                    className="impact-progress bar amber"
                    onClick={() => {
                      redirectPage("/impacts-tracking?selected=satisfaction");
                    }}
                  ></div>
                </div>
                <div className="impact-title  sec-title">
                  <span>Data Driven Decisions</span>
                  <div
                    className="impact-progress bar red"
                    onClick={() => {
                      redirectPage("/impacts-tracking?selected=compliants");
                    }}
                  ></div>
                </div>
              </div>
              <div className="imeasure">
                <div className="tmeasure">
                  <span>Target Measure</span>
                  <ul>
                    <li className="red-text">100%</li>
                    <li className="amber-text">90%</li>
                    <li className="retention">100%</li>
                  </ul>
                </div>
                <div className="cmeasure">
                  <span>Current Measure</span>
                  <ul>
                    <li className="red-text">
                      30% <img src={ArrowRed} alt="#" className="rotate-down"/>
                    </li>
                    <li className="amber-text">
                      80% <img src={ArrowAmber} alt="#"  className="rotate-down"/>
                    </li>
                    <li className="red-text">
                      45% <img src={ArrowRed} alt="#" className="rotate-down"/>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="objective-more-details">
        <div className="cont">
          <div className="linked-projects">
            <div className="top-title">
              <div className="lines gap-right">
                <hr />
              </div>
              <div>
                <span>Linked Initiatives</span>
              </div>
              <div className="lines gap-left">
                <hr />
              </div>
            </div>

            <div className="counter-linked">
              <span>82</span>
            </div>
          </div>
          <div className="initiatives">
            <div className="top-title">
              <div className="lines gap-right">
                <hr />
              </div>
              <div>
                <span>Initiatives</span>
              </div>
              <div className="lines gap-left">
                <hr />
              </div>
            </div>

            <div className="detail-initiate">
              <div className="left-track">
                <div className="on-track-cover">
                  <span className="on-track">On Track</span>
                  <span className="track-count">30</span>
                </div>

                <div className="moderate-cover">
                  <span className="moderate">Moderate Delay</span>
                  <span className="mod-count">20</span>
                </div>
              </div>
              <div className="right-track">
                <div className="sig-cover">
                  <span className="sig-delay">Significant Delay</span>
                  <span className="sig-count">30</span>
                </div>

                <div className="not-cover">
                  <span className="not-started">Not Started</span>
                  <span className="not-count">2</span>
                </div>
              </div>
            </div>
          </div>
          <div className="tile right">
            <div className="icon">
              <img src={AB} alt="#" />
            </div>
            <span>Approved Budget</span>
            <span>{ convertValues('19234545343') }</span>
          </div>
          <div className="tile right">
            <div className="icon">
              <img src={CV} alt="#" />
            </div>
            <span>Contracted Value</span>
            <span>{ convertValues('5623421133') }</span>
          </div>
          <div className="tile right">
            <div className="icon">
              <img src={SV} alt="#" />
            </div>
            <span>Spent Value</span>
            <span>{ convertValues('95673432') }</span>
          </div>
        </div>
      </section>
      {/* Section & Details End */}

      {/* Section & Details Start */}
      <section className="objective-tile">
        <div className="left-content">
          <div
            className="improve-morale"
            onClick={() => {
              redirectPage("/impacts-tracking-dashboard?so=3");
            }}
          >
            <div className="green-patch">
              <img src={Diamond} alt="icon1" />
            </div>

            <div className="improve-morale-text">
              <div className="green-circle">
                <span>3</span>
              </div>
              <span>Achieve joint operational excellence</span>
            </div>
          </div>
        </div>
        <div className="right-content">
          <div className="impact-status">
            <div className="top-title">
              <div className="lines gap-right">
                <hr />
              </div>
              <div>
                <span>Impact Status</span>
              </div>
              <div className="lines gap-left">
                <hr />
              </div>
            </div>

            <div className="istatus-measures">
              <div className="istatus">
                <div className="impact-title">
                  <span>Operational Rediness</span>
                  <div
                    className="impact-progress bar green"
                    onClick={() => {
                      redirectPage("/impacts-tracking?selected=retention");
                    }}
                  ></div>
                </div>
                <div className="impact-title  sec-title">
                  <span>Apply New Doctrine</span>
                  <div
                    className="impact-progress bar  red"
                    onClick={() => {
                      redirectPage("/impacts-tracking?selected=satisfaction");
                    }}
                  ></div>
                </div>
                <div className="impact-title  sec-title">
                  <span>Unmet Requirements</span>
                  <div
                    className="impact-progress bar amber"
                    onClick={() => {
                      redirectPage("/impacts-tracking?selected=compliants");
                    }}
                  ></div>
                </div>
              </div>
              <div className="imeasure">
                <div className="tmeasure">
                  <span>Target Measure</span>
                  <ul>
                    <li className="green-text">90%</li>
                    <li className="red-text">90%</li>
                    <li className="amber-text">10%</li>
                  </ul>
                </div>
                <div className="cmeasure">
                  <span>Current Measure</span>
                  <ul>
                    <li className="green-text">
                      85% <img src={ArrowGreen} alt="#" className="rotate-down"/>
                    </li>
                    <li className="red-text">
                      70% <img src={ArrowGreen} alt="#" className="rotate-down" />
                    </li>
                    <li className="amber-text">
                      20% <img src={ArrowRed} alt="#" className="rotate-up"/>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="objective-more-details">
        <div className="cont">
          <div className="linked-projects">
            <div className="top-title">
              <div className="lines gap-right">
                <hr />
              </div>
              <div>
                <span>Linked Initiatives</span>
              </div>
              <div className="lines gap-left">
                <hr />
              </div>
            </div>

            <div className="counter-linked">
              <span>102</span>
            </div>
          </div>
          <div className="initiatives">
            <div className="top-title">
              <div className="lines gap-right">
                <hr />
              </div>
              <div>
                <span>Initiatives</span>
              </div>
              <div className="lines gap-left">
                <hr />
              </div>
            </div>

            <div className="detail-initiate">
              <div className="left-track">
                <div className="on-track-cover">
                  <span className="on-track">On Track</span>
                  <span className="track-count">50</span>
                </div>

                <div className="moderate-cover">
                  <span className="moderate">Moderate Delay</span>
                  <span className="mod-count">40</span>
                </div>
              </div>
              <div className="right-track">
                <div className="sig-cover">
                  <span className="sig-delay">Significant Delay</span>
                  <span className="sig-count">10</span>
                </div>

                <div className="not-cover">
                  <span className="not-started">Not Started</span>
                  <span className="not-count">2</span>
                </div>
              </div>
            </div>
          </div>
          <div className="tile right">
            <div className="icon">
              <img src={AB} alt="#" />
            </div>
            <span>Approved Budget</span>
            <span>{ convertValues('19234545343') }</span>
          </div>
          <div className="tile right">
            <div className="icon">
              <img src={CV} alt="#" />
            </div>
            <span>Contracted Value</span>
            <span>{ convertValues('5623421133') }</span>
          </div>
          <div className="tile right">
            <div className="icon">
              <img src={SV} alt="#" />
            </div>
            <span>Spent Value</span>
            <span>{ convertValues('95673432') }</span>
          </div>
        </div>
      </section>
      {/* Section & Details End */}

      {/* Section & Details Start */}
      <section className="objective-tile">
        <div className="left-content">
          <div
            className="improve-morale"
            onClick={() => {
              redirectPage("/impacts-tracking-dashboard?so=4");
            }}
          >
            <div className="green-patch">
              <img src={Ammuni} alt="icon1" />
            </div>

            <div className="improve-morale-text">
              <div className="green-circle">
                <span>4</span>
              </div>
              <span>Modernize weaponry and armament systems</span>
            </div>
          </div>
        </div>
        <div className="right-content">
          <div className="impact-status">
            <div className="top-title">
              <div className="lines gap-right">
                <hr />
              </div>
              <div>
                <span>Impact Status</span>
              </div>
              <div className="lines gap-left">
                <hr />
              </div>
            </div>

            <div className="istatus-measures">
              <div className="istatus">
                <div className="impact-title">
                  <span>Interoperability</span>
                  <div
                    className="impact-progress  bar red"
                    onClick={() => {
                      redirectPage("/impacts-tracking?selected=retention");
                    }}
                  ></div>
                </div>
                <div className="impact-title  sec-title">
                  <span>Increase Survivability</span>
                  <div
                    className="impact-progress bar green"
                    onClick={() => {
                      redirectPage("/impacts-tracking?selected=satisfaction");
                    }}
                  ></div>
                </div>
                <div className="impact-title  sec-title">
                  <span>Employee New Systems</span>
                  <div
                    className="impact-progress  bar amber"
                    onClick={() => {
                      redirectPage("/impacts-tracking?selected=compliants");
                    }}
                  ></div>
                </div>
              </div>
              <div className="imeasure">
                <div className="tmeasure">
                  <span>Target Measure</span>
                  <ul>
                    <li className="red-text">75%</li>
                    <li className="green-text">90%</li>
                    <li className="amber-text">90%</li>
                  </ul>
                </div>
                <div className="cmeasure">
                  <span>Current Measure</span>
                  <ul>
                    <li className="red-text">
                      40% <img src={ArrowRed} alt="#" className="rotate-down"/>
                    </li>
                    <li className="green-text">
                      85% <img src={ArrowGreen} alt="#" className="rotate-down"/>
                    </li>
                    <li className="amber-text">
                      80% <img src={ArrowAmber} alt="#" className="rotate-down"/>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="objective-more-details">
        <div className="cont">
          <div className="linked-projects">
            <div className="top-title">
              <div className="lines gap-right">
                <hr />
              </div>
              <div>
                <span>Linked Initiatives</span>
              </div>
              <div className="lines gap-left">
                <hr />
              </div>
            </div>

            <div className="counter-linked">
              <span>12</span>
            </div>
          </div>
          <div className="initiatives">
            <div className="top-title">
              <div className="lines gap-right">
                <hr />
              </div>
              <div>
                <span>Initiatives</span>
              </div>
              <div className="lines gap-left">
                <hr />
              </div>
            </div>

            <div className="detail-initiate">
              <div className="left-track">
                <div className="on-track-cover">
                  <span className="on-track">On Track</span>
                  <span className="track-count">4</span>
                </div>

                <div className="moderate-cover">
                  <span className="moderate">Moderate Delay</span>
                  <span className="mod-count">4</span>
                </div>
              </div>
              <div className="right-track">
                <div className="sig-cover">
                  <span className="sig-delay">Significant Delay</span>
                  <span className="sig-count">2</span>
                </div>

                <div className="not-cover">
                  <span className="not-started">Not Started</span>
                  <span className="not-count">2</span>
                </div>
              </div>
            </div>
          </div>
          <div className="tile right">
            <div className="icon">
              <img src={AB} alt="#" />
            </div>
            <span>Approved Budget</span>
            <span>{ convertValues('19234545343') }</span>
          </div>
          <div className="tile right">
            <div className="icon">
              <img src={CV} alt="#" />
            </div>
            <span>Contracted Value</span>
            <span>{ convertValues('5623421133') }</span>
          </div>
          <div className="tile right">
            <div className="icon">
              <img src={SV} alt="#" />
            </div>
            <span>Spent Value</span>
            <span>{ convertValues('95673432') }</span>
          </div>
        </div>
      </section>
      {/* Section & Details End */}

      {/* Section & Details Start */}
      <section className="objective-tile">
        <div className="left-content">
          <div
            className="improve-morale"
            onClick={() => {
              redirectPage("/impacts-tracking-dashboard?so=5");
            }}
          >
            <div className="green-patch">
              <img src={Military} alt="icon1" />
            </div>

            <div className="improve-morale-text">
              <div className="green-circle">
                <span>5</span>
              </div>
              <span>
                Enhance spending efficiency and support localization of military
                industry
              </span>
            </div>
          </div>
        </div>
        <div className="right-content">
          <div className="impact-status">
            <div className="top-title">
              <div className="lines gap-right">
                <hr />
              </div>
              <div>
                <span>Impact Status</span>
              </div>
              <div className="lines gap-left">
                <hr />
              </div>
            </div>

            <div className="istatus-measures">
              <div className="istatus">
                <div className="impact-title">
                  <span>Reduce Financial Risk</span>
                  <div
                    className="impact-progress bar green"
                    onClick={() => {
                      redirectPage("/impacts-tracking?selected=retention");
                    }}
                  ></div>
                </div>
                <div className="impact-title  sec-title">
                  <span>Increase WS Lifespan</span>
                  <div
                    className="impact-progress bar red"
                    onClick={() => {
                      redirectPage("/impacts-tracking?selected=satisfaction");
                    }}
                  ></div>
                </div>
                <div className="impact-title  sec-title">
                  <span>Increase Local Markets</span>
                  <div
                    className="impact-progress bar red"
                    onClick={() => {
                      redirectPage("/impacts-tracking?selected=compliants");
                    }}
                  ></div>
                </div>
              </div>
              <div className="imeasure">
                <div className="tmeasure">
                  <span>Target Measure</span>
                  <ul>
                    <li className="green-text">20%</li>
                    <li className="red-text">5 Years</li>
                    <li className="red-text">50%</li>
                  </ul>
                </div>
                <div className="cmeasure">
                  <span>Current Measure</span>
                  <ul>
                    <li className="green-text">
                      20% <img src={ArrowGreen} alt="#" />
                    </li>
                    <li className="red-text">
                      3 Years <img src={ArrowRed} alt="#" className="rotate-down"/>
                    </li>
                    <li className="red-text">
                      30% <img src={ArrowRed} alt="#" className="rotate-down"/>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="objective-more-details">
        <div className="cont">
          <div className="linked-projects">
            <div className="top-title">
              <div className="lines gap-right">
                <hr />
              </div>
              <div>
                <span>Linked Initiatives</span>
              </div>
              <div className="lines gap-left">
                <hr />
              </div>
            </div>

            <div className="counter-linked">
              <span>13</span>
            </div>
          </div>
          <div className="initiatives">
            <div className="top-title">
              <div className="lines gap-right">
                <hr />
              </div>
              <div>
                <span>Initiatives</span>
              </div>
              <div className="lines gap-left">
                <hr />
              </div>
            </div>

            <div className="detail-initiate">
              <div className="left-track">
                <div className="on-track-cover">
                  <span className="on-track">On Track</span>
                  <span className="track-count">5</span>
                </div>

                <div className="moderate-cover">
                  <span className="moderate">Moderate Delay</span>
                  <span className="mod-count">5</span>
                </div>
              </div>
              <div className="right-track">
                <div className="sig-cover">
                  <span className="sig-delay">Significant Delay</span>
                  <span className="sig-count">2</span>
                </div>

                <div className="not-cover">
                  <span className="not-started">Not Started</span>
                  <span className="not-count">1</span>
                </div>
              </div>
            </div>
          </div>
          <div className="tile right">
            <div className="icon">
              <img src={AB} alt="#" />
            </div>
            <span>Approved Budget</span>
            <span>{ convertValues('19234545343') }</span>
          </div>
          <div className="tile right">
            <div className="icon">
              <img src={CV} alt="#" />
            </div>
            <span>Contracted Value</span>
            <span>{ convertValues('5623421133') }</span>
          </div>
          <div className="tile right">
            <div className="icon">
              <img src={SV} alt="#" />
            </div>
            <span>Spent Value</span>
            <span>{ convertValues('95673432') }</span>
          </div>
        </div>
      </section>
      {/* Section & Details End */}
    </>
  );
}

export default StrategicObjectives;
